<template>
<div class="chapter">
<div class="inner_page">
<div id="fm03">
<p class="title"><span>OUR LADY</span></p>
<p class="title1a"><span>OF BABYLON</span></p>
<p class="title1"><em class="italic">A NOVEL</em></p>
<p class="title2">J<span class="small1">OHN</span> R<span class="small1">ECHY</span></p>
<p class="title3a"><img alt="" class="jpg" src="images/img_0001.jpg"/></p>
<p class="title4a"><span class="bold">GROVE PRESS</span></p>
<p class="title4a"><em class="italic">New York</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?5a9a03c8